import React from "react";
import InfoPerson from "./InfoPerson";
import Qualification from "./Qualification";
import {ResultTray} from "../../../services/interface/trays/result-tray";
import {ResultAnalysisMock} from "../../../test/mock/TraysMock";
export default function Result() {
    const [result, setResult] = React.useState<ResultTray | undefined>(ResultAnalysisMock)

    return(
        <div className={'max-w-[1000px] pt-8 mx-auto min-h-[80vh] flex flex-col gap-4'}>
            <InfoPerson {...{result}}/>
            <Qualification {...{result}}/>
        </div>
    )
}
